import React from "react";
import { Box } from "@chakra-ui/react";
import LoginForm from "../../views/Dashboard/components/auth/login/LoginForm";
import "@fontsource/poppins/400.css";

export default function AuthBox() {
  return (
    <Box
      w="320px"
      p="20px"
      pos="relative"
      bg="rgba(255,255,255,0.1)"
      border="1px solid #fff"
      borderRadius="10px"
      boxShadow="0 4px 6px rgba(0,0,0,0.1)"
      backdropFilter="blur(5px)"
      fontFamily="Poppins, sans-serif"
      height="auto"
    >
      <LoginForm />
    </Box>
  );
}
